import { useMemo } from 'react';
import { useUser } from '../contexts/UserContext';
import {
  resolveRenderSurfaceSlugSession,
  type RenderSurfaceSlugSession,
} from '../utils/renderSurfaceSlugSession';

/** Resolve kryspace workspace slug for company-artifacts from header company selection. */
export function useCompanyArtifactsSlugSession(): RenderSurfaceSlugSession {
  const { selectedCompany, availableCompanies, user } = useUser();

  return useMemo(
    () =>
      resolveRenderSurfaceSlugSession({
        selectedCompany,
        availableCompanies,
        userCompanyId: user?.companyId,
      }),
    [selectedCompany, availableCompanies, user?.companyId]
  );
}
